import { render, staticRenderFns } from "./_base-simpleDataTable.vue?vue&type=template&id=801fa700&scoped=true&"
import script from "./_base-simpleDataTable.vue?vue&type=script&lang=js&"
export * from "./_base-simpleDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_babel-co_0dbbf42f62185882c0604707ed980ddd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801fa700",
  null
  
)

export default component.exports